module.exports = __webpack_public_path__ + "static/power4-2@2x-060d02dbbd82a00370e77ab64e9f6e59.png";